import { render, staticRenderFns } from "./DynamicFieldsRenderer.vue?vue&type=template&id=9f771270&scoped=true"
import script from "./DynamicFieldsRenderer.vue?vue&type=script&lang=js"
export * from "./DynamicFieldsRenderer.vue?vue&type=script&lang=js"
import style0 from "./DynamicFieldsRenderer.vue?vue&type=style&index=0&id=9f771270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f771270",
  null
  
)

export default component.exports